// 头部
import { Button } from 'antd';

import { RootObject, EasyDeployHeaderJumpContent } from '../../type';

import './style.less';


const EasyDeployHeader = (props: RootObject["easyDeployHeader"]) => {
    return (
        <div className="easy_deploy_header">
            <div className="header_title">
                {props.easyDeployHeaderTitle ?? ""}
            </div>
            <div className="header_content">
                {props.easyDeployHeaderContent}
            </div>
            <div className="header_btnList">
                {
                    props.easyDeployHeaderJumpContent.map((value: EasyDeployHeaderJumpContent, index: number) => {
                        return (
                            //@ts-ignore
                            <Button className="btn" type="primary" key={index}>
                                <a className="btn_a" href={value.detailLink} target='_blank' rel='noreferrer'>{value.title}</a>
                            </Button>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default EasyDeployHeader;